/**
 * Saved-assessment copy (ALC-4522): the "Salvar avaliação" command and the per-control history
 * dialog. Error copy is keyed by the API's stable error code, never by server text.
 */
export const historyPtBr = {
  action: 'Histórico',
  actionLabel: 'Ver histórico do controle {{controlId}}',
  title: 'Histórico do controle {{controlId}}',
  description: 'Avaliações salvas, pendências e revisões deste controle no período.',
  loading: 'Carregando histórico',
  loadError: 'Não foi possível carregar o histórico.',
  retry: 'Tentar novamente',
  empty: 'Nenhuma avaliação foi salva para este controle neste período.',
  emptyHint: 'Use “Salvar avaliação” na seção de controles para registrar o resultado atual.',
  restricted:
    'Itens confidenciais da folha, e as revisões que dependem deles, não aparecem para você.',
  savedEvidenceWithheld:
    'As evidências das avaliações salvas ficam ocultas porque podem conter dados que você não pode ver. O resultado e as datas continuam visíveis.',
  savedEvidenceEmpty: 'Evidências ocultas para este acesso.',
  truncated: 'Mostrando apenas os registros mais recentes.',
  outOfDate: 'Desatualizada — salve uma nova avaliação',
  assessments: {
    title: 'Avaliações',
    current: 'Atual',
    periodStatus: {
      CLOSED: 'Salva com o período fechado',
      LOCKED: 'Salva com o período bloqueado',
    },
    showFindings: 'Ver pendências desta avaliação',
    hideFindings: 'Ocultar pendências desta avaliação',
    findingsAsSaved: 'Pendências como esta avaliação as viu, sem mudanças posteriores.',
    findingsEmpty: 'Esta avaliação não encontrou pendências.',
    findingsLoading: 'Carregando as pendências da avaliação',
    findingsLoadError: 'Não foi possível carregar as pendências desta avaliação.',
    observationsTitle: 'Cobertura desta avaliação',
    observation_one: '{{count}} item adicional nesta avaliação',
    observation_other: '{{count}} itens adicionais nesta avaliação',
    publication: {
      PUBLISHED: 'Publicada',
      REJECTED_STALE: 'Substituída por uma avaliação mais recente',
      NOT_PUBLISHED: 'Não publicada',
    },
    observedAt: 'Avaliada em {{date}}',
    savedBy: 'Salva por {{name}}',
    ruleVersion: 'Regra {{version}}',
    noResult: 'Sem resultado: a avaliação falhou e nada foi considerado.',
  },
  findings: {
    title: 'Pendências',
    empty: 'Nenhuma pendência registrada.',
    subject: 'Item {{id}}',
    otherReason: 'Condição que requer revisão',
    reviewCompetencyEstimated: 'Revisão contábil pendente; competência estimada',
    reviewCompetencyAndAmountUnavailable:
      'Revisão contábil pendente; competência estimada e valor indisponível',
    noAmount: 'Sem valor',
    status: {
      OPEN: 'Aberta',
      RESOLVED: 'Resolvida',
      SUPERSEDED: 'Fora da regra atual',
    },
    firstSeen: 'Vista pela primeira vez em {{date}}',
    lastSeen: 'Última vez em {{date}}',
    resolvedAt: 'Resolvida em {{date}}',
    supersededAt: 'Fora da regra desde {{date}}',
    reopened_one: 'Reaberta {{count}} vez',
    reopened_other: 'Reaberta {{count}} vezes',
  },
  reviews: {
    title: 'Revisões',
    empty: 'Nenhuma revisão registrada.',
    decision: {
      ACCEPTED: 'Aceita',
      REJECTED: 'Rejeitada',
      KEEP: 'Mantida',
    },
    wholeControl: 'Controle inteiro',
    oneFinding: 'Uma pendência',
    reviewedBy: 'Por {{name}} em {{date}}',
    evidence: 'Evidência: {{evidence}}',
    valid: 'Válida',
    invalidated: 'Revisão invalidada',
    invalidatedAt: 'Invalidada em {{date}}',
    invalidation: {
      SOURCE_CHANGED: 'Os dados de origem mudaram depois desta revisão.',
      RULE_CHANGED: 'A regra do controle mudou depois desta revisão.',
    },
  },
  save: {
    action: 'Salvar avaliação',
    published_one: '{{count}} controle atualizado no histórico.',
    published_other: '{{count}} controles atualizados no histórico.',
    stale_one: '{{count}} avaliação ficou só no histórico, pois já existe uma mais recente.',
    stale_other: '{{count}} avaliações ficaram só no histórico, pois já existem mais recentes.',
    failed_one: 'A avaliação de {{count}} controle falhou e não substituiu a anterior.',
    failed_other: 'A avaliação de {{count}} controles falhou e não substituiu a anterior.',
    notSaved_one: '{{count}} controle não foi salvo ({{controls}}). Os demais foram salvos.',
    notSaved_other: '{{count}} controles não foram salvos ({{controls}}). Os demais foram salvos.',
    error: 'Não foi possível salvar a avaliação.',
  },
};

export const historyEn: typeof historyPtBr = {
  action: 'History',
  actionLabel: 'View history of control {{controlId}}',
  title: 'History of control {{controlId}}',
  description: 'Saved assessments, findings and reviews of this control for the period.',
  loading: 'Loading history',
  loadError: 'Could not load the history.',
  retry: 'Try again',
  empty: 'No assessment has been saved for this control in this period.',
  emptyHint: 'Use “Save assessment” in the controls section to record the current result.',
  restricted:
    'Confidential payroll items, and the reviews that depend on them, are hidden from you.',
  savedEvidenceWithheld:
    'Evidence in saved assessments is hidden because it may contain data you cannot see. The outcome and dates remain visible.',
  savedEvidenceEmpty: 'Evidence is hidden for this access.',
  truncated: 'Showing only the most recent records.',
  outOfDate: 'Out of date — save a new assessment',
  assessments: {
    title: 'Assessments',
    current: 'Current',
    periodStatus: {
      CLOSED: 'Saved with the period closed',
      LOCKED: 'Saved with the period locked',
    },
    showFindings: 'Show the findings of this assessment',
    hideFindings: 'Hide the findings of this assessment',
    findingsAsSaved: 'Findings as this assessment saw them, unaffected by later changes.',
    findingsEmpty: 'This assessment found no findings.',
    findingsLoading: 'Loading the findings of the assessment',
    findingsLoadError: 'Could not load the findings of this assessment.',
    observationsTitle: 'Coverage in this assessment',
    observation_one: '{{count}} additional item in this assessment',
    observation_other: '{{count}} additional items in this assessment',
    publication: {
      PUBLISHED: 'Published',
      REJECTED_STALE: 'Superseded by a more recent assessment',
      NOT_PUBLISHED: 'Not published',
    },
    observedAt: 'Assessed on {{date}}',
    savedBy: 'Saved by {{name}}',
    ruleVersion: 'Rule {{version}}',
    noResult: 'No result: the assessment failed and nothing was counted.',
  },
  findings: {
    title: 'Findings',
    empty: 'No findings recorded.',
    subject: 'Item {{id}}',
    otherReason: 'Condition requiring review',
    reviewCompetencyEstimated: 'Pending accounting review; estimated competency',
    reviewCompetencyAndAmountUnavailable:
      'Pending accounting review; estimated competency and unavailable amount',
    noAmount: 'No amount',
    status: {
      OPEN: 'Open',
      RESOLVED: 'Resolved',
      SUPERSEDED: 'No longer in the current rule',
    },
    firstSeen: 'First seen on {{date}}',
    lastSeen: 'Last seen on {{date}}',
    resolvedAt: 'Resolved on {{date}}',
    supersededAt: 'Out of the rule since {{date}}',
    reopened_one: 'Reopened {{count}} time',
    reopened_other: 'Reopened {{count}} times',
  },
  reviews: {
    title: 'Reviews',
    empty: 'No reviews recorded.',
    decision: {
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      KEEP: 'Kept',
    },
    wholeControl: 'Whole control',
    oneFinding: 'One finding',
    reviewedBy: 'By {{name}} on {{date}}',
    evidence: 'Evidence: {{evidence}}',
    valid: 'Valid',
    invalidated: 'Review invalidated',
    invalidatedAt: 'Invalidated on {{date}}',
    invalidation: {
      SOURCE_CHANGED: 'The source data changed after this review.',
      RULE_CHANGED: 'The control rule changed after this review.',
    },
  },
  save: {
    action: 'Save assessment',
    published_one: '{{count}} control updated in the history.',
    published_other: '{{count}} controls updated in the history.',
    stale_one:
      '{{count}} assessment was kept in the history only: a more recent one already exists.',
    stale_other:
      '{{count}} assessments were kept in the history only: more recent ones already exist.',
    failed_one: 'The assessment of {{count}} control failed and did not replace the previous one.',
    failed_other:
      'The assessment of {{count}} controls failed and did not replace the previous ones.',
    notSaved_one: '{{count}} control was not saved ({{controls}}). The others were saved.',
    notSaved_other: '{{count}} controls were not saved ({{controls}}). The others were saved.',
    error: 'Could not save the assessment.',
  },
};

/** Stable API error codes of the assessment, history and review routes (merged into `errors`). */
export const assessmentErrorsPtBr = {
  FINANCIAL_CONTROL_ASSESSMENT_NOT_FOUND: 'Avaliação não encontrada para este controle.',
  FINANCIAL_CONTROL_FINDING_NOT_FOUND: 'Pendência não encontrada nesta avaliação.',
  FINANCIAL_CONTROL_REVIEW_STALE:
    'Há uma avaliação mais recente. Atualize a tela e revise a avaliação atual.',
  FINANCIAL_CONTROL_REVIEW_REQUIRES_FULL_VISIBILITY:
    'Registrar revisões exige acesso completo aos dados deste controle.',
  FINANCIAL_CONTROL_SAVE_FAILED:
    'Não foi possível salvar a avaliação dos controles. Tente novamente.',
};

export const assessmentErrorsEn: typeof assessmentErrorsPtBr = {
  FINANCIAL_CONTROL_ASSESSMENT_NOT_FOUND: 'Assessment not found for this control.',
  FINANCIAL_CONTROL_FINDING_NOT_FOUND: 'Finding not found in this assessment.',
  FINANCIAL_CONTROL_REVIEW_STALE:
    'A more recent assessment exists. Refresh the screen and review the current one.',
  FINANCIAL_CONTROL_REVIEW_REQUIRES_FULL_VISIBILITY:
    "Recording reviews requires full access to this control's data.",
  FINANCIAL_CONTROL_SAVE_FAILED: 'Could not save the assessment of the controls. Try again.',
};
